module.exports = __webpack_public_path__ + "img/academy_pos_leadership-sm.ef2451ae.png";